// extracted by mini-css-extract-plugin
export default {"quantity":"ALgkc"};